import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsZennComponent } from './simple-icons-zenn.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsZennComponent ],
    exports:      [ SimpleIconsZennComponent ],
    bootstrap:    []
})
export class SimpleIconsZennModule {}
